<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`"
      height="100%"
      color="#FAFAFA"
      style="display: flex; flex-direction: column;"
    >
      <v-card-title style="background-color:green; color:white;padding-top:5px;padding-bottom:5px;">
        <v-icon left color="white">control_camera</v-icon>
        <span>{{equipment.TypeName}}</span>
        <v-spacer></v-spacer>
        <span>{{equipment.EquipmentId}}</span>
        <v-btn v-if="isAuthenticated" icon @click.prevent="favClick" dark>
          <v-icon
            :color="equipment.IsFavorite ? 'blue' : ''"
          >{{equipment.IsFavorite ? 'star' : 'star_border'}}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout column>
          <v-layout
            align-center
            class="subheading font-weight-light"
            v-if="equipment.ResponsibleName"
          >
            <v-icon class="mr-1" color="orange">person</v-icon>
            <span>{{ equipment.ResponsibleName }}</span>
          </v-layout>
          <router-link :to="{ name: 'equipment', params: { equipmentId: equipment.EquipmentId }}">
            <span class="headline font-weight-bold text--lighten-blue">{{equipment.Name}}</span>
          </router-link>

          <span
            v-if="equipment.Description && equipment.Description.length && equipment.Description.length > 200"
            class="subheading font-weight-light"
          >{{equipment.Description.substring(0, 200)}}...</span>
          <span v-else class="subheading font-weight-light">{{equipment.Description}}</span>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="grow">
        <v-layout wrap style="height: 100%" align-content-end justify-start>
          <v-layout v-if="equipment.FactoryNumber">
            <v-icon class="mr-1" color="blue">class</v-icon>
            <span wrap>{{ equipment.FactoryNumber }}</span>
          </v-layout>
          <!-- <v-layout v-if="equipment.ObjectName">
            <v-icon class="mr-1" color="cyan">home</v-icon>
            <span wrap class="subheading mr-2">{{ equipment.ObjectName }}</span>
          </v-layout>-->
          <v-layout v-if="equipment.DepartmentName">
            <v-icon class="mr-1" color="teal">domain</v-icon>
            <span wrap class="subheading mr-2">{{ equipment.DepartmentName }}</span>
          </v-layout>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    equipment: Object
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    }
  },
  methods: {
    ...mapActions(['toggleEquipmentFav']),
    favClick() {
      this.toggleEquipmentFav(this.equipment)
    }
  }
}
</script>

<style scoped>
a {
  color: rgb(0, 153, 255) !important;
}
</style>
